/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { AutocompleteChangeReason, Button, Chip } from "@mui/material";
import { CompanyModel } from "../../Utils/Models";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import CompanyForm from "./CompanyForm";

export const CRUDContext = createContext(new CompanyModel());

export default function CompaniesTable() {
  const [contextValue, setContextValue] = useState(new CompanyModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();

  /**
   *
   */
  const companyColumns = [
    {
      label: `${Vocabulary.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.CUI}`,
      name: "CUI",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.phoneNumber}`,
      name: "phoneNumber",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.email}`,
      name: "email",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.workPoints}`,
      name: "visible",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (rowData: boolean) => {
          return (
            <>
              <Chip
                color="primary"
                key={rowData.toString()}
                label={rowData ? Vocabulary.open : Vocabulary.closed}
                style={{
                  margin: 5,
                }}
              />
            </>
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.companies}
          columns={companyColumns}
          CRUDEndPoint={endpoints.company.main}
          id={TablesIds.company}
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new CompanyModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new CompanyModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.companyForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <CompanyForm
                setContextValue={(
                  e: any,
                  client: CompanyModel | null,
                  reason: AutocompleteChangeReason,
                  details?: any
                ) => ({})}
                onClose={() => {
                  setOpen(false);
                  setTriggerReload(
                    triggerReload !== undefined ? !triggerReload : false
                  );
                  setContextValue(new CompanyModel());
                }}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        />
      </CRUDContext.Provider>
    </div>
  );
}
